export const CHAT_THEME = {
	PAPER: 'paper',
	LIGHT: 'light',
	DARK: 'dark',
} as const;

export type ChatTheme = (typeof CHAT_THEME)[keyof typeof CHAT_THEME];

export const CHAT_THEME_OPTIONS: Array<{ key: ChatTheme; label: string }> = [
	{ key: CHAT_THEME.PAPER, label: 'Paper' },
	{ key: CHAT_THEME.LIGHT, label: 'Light' },
	{ key: CHAT_THEME.DARK, label: 'Dark' },
];

/** Must match the server's conversation model allowlist. */
export const CONVERSATION_MODEL_OPTIONS = [
	{ key: 'openai/gpt-6.1-sol', label: 'GPT-6.1 Sol', contextWindow: 1_050_000 },
	{ key: 'openai/gpt-6-luna', label: 'GPT-6 Luna', contextWindow: 1_050_000 },
	{ key: 'openai/gpt-6-sol', label: 'GPT-6 Sol', contextWindow: 1_050_000 },
	{ key: 'openai/gpt-5.6-sol', label: 'GPT-5.6 Sol', contextWindow: 1_050_000 },
] as const;

export type ConversationModel = (typeof CONVERSATION_MODEL_OPTIONS)[number]['key'];

export const DEFAULT_CONVERSATION_MODEL: ConversationModel = 'openai/gpt-6.1-sol';

export const CHAT_PANEL_WIDTH = {
	DEFAULT: 560,
	MIN: 280,
	MAX: 720,
	COLLAPSE_THRESHOLD: 240,
	RAIL: 40,
	DRAG_THRESHOLD: 3,
} as const;
